import { useState } from 'react';
import { toolService } from '../../../services';

export function MacOUIRow({ index }) {
  const [mac, setMac] = useState('');
  const [result, setResult] = useState('');
  const [error, setError] = useState(false);

  const lookupOUI = async () => {
    const cleanedMac = mac.trim().toUpperCase().replace(/[^0-9A-F]/g, '');
    if (!/^[0-9A-F]{12}$/.test(cleanedMac)) {
      setResult('Invalid MAC format');
      setError(true);
      return;
    }

    setResult('Looking up...');
    setError(false);
    try {
      const data = await toolService.macLookup(cleanedMac);
      setResult(data.manufacturer || 'Manufacturer not found');
    } catch {
      setResult('Lookup error');
      setError(true);
    }
  };

  return (
    <div className="flex border-b border-gray-200 last:border-b-0 py-3 items-center">
      {/* Index cell */}
      <div className="w-12 text-center font-bold text-blue-400 select-none">
        {index}
      </div>

      {/* Input cell */}
      <div className="flex-1 px-2">
        <input
          type="text"
          placeholder="AA:BB:CC:DD:EE:FF"
          value={mac}
          onChange={(e) => setMac(e.target.value)}
          className="
            w-full
            bg-[#f6faff] 
            text-[#24272d] 
            uppercase
            text-base
            rounded-md 
            border-[1.5px] border-[#b5c7df]
            px-3 py-2
            outline-none
            transition-colors duration-200
            focus:border-[#45a7ed]
            focus:bg-[#eaf4fd]
          "
        />
      </div>

      {/* Button cell */}
      <div className="w-32 px-2">
        <button
          onClick={lookupOUI}
          className="
            w-full
            bg-gradient-to-r from-[#2e7bed] to-[#56b3fa] 
            text-white 
            rounded-md 
            px-3 py-2
            font-medium
            shadow-sm
            hover:from-[#295dbe] hover:to-[#39a5fc]
            transition duration-150
            cursor-pointer
            select-none
          "
        >
          Lookup
        </button>
      </div>

      {/* Result cell */}
      <div className="flex-1 px-2">
        <span
          className={`
            inline-block
            min-w-[110px]
            rounded-md
            px-2 py-[6px]
            text-sm font-medium
            border
            shadow-sm
            ${
              error
                ? 'bg-[#ffeaea] border-[#f5c2c2] text-[#b12b2b]'
                : 'bg-[#eaf4fd] border-[#d1e8fb] text-[#285085]'
            }
          `}
        >
          {result}
        </span>
      </div>
    </div>
  );
}
